import { render, staticRenderFns } from "./Status.vue?vue&type=template&id=2013d110"
import script from "./Status.vue?vue&type=script&lang=js"
export * from "./Status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2013d110')) {
      api.createRecord('2013d110', component.options)
    } else {
      api.reload('2013d110', component.options)
    }
    module.hot.accept("./Status.vue?vue&type=template&id=2013d110", function () {
      api.rerender('2013d110', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/otro-documento/Status.vue"
export default component.exports